import React, { useState } from 'react';
import Sidebar from './Sidebar/Sidebar';
import Header from './Header/Header';
import './MainLayout.css';

const MainLayout = ({ activePage, onNavigate, children }) => {
  const [isCollapsed, setIsCollapsed] = useState(false);

  return (
    <div className={`main-layout ${isCollapsed ? 'main-layout--collapsed' : ''}`}>
      <Sidebar 
        activePage={activePage} 
        onNavigate={onNavigate} 
        collapsed={isCollapsed}
        onToggle={() => setIsCollapsed(!isCollapsed)}
      />

      <div className="main-layout__content">
        <Header 
          activePage={activePage} 
          onNavigate={onNavigate} 
          onToggleSidebar={() => setIsCollapsed(!isCollapsed)} 
        />

        <main className="main-layout__main" id="main-content" tabIndex="-1">
          {children}
        </main>
      </div>
    </div>
  );
};

export default MainLayout;
